import { Box, Stack, Typography } from "@mui/material";
import EditPencilIcon from "src/assets/icons/EditPencilIcon";
import WhiteCard from "src/shared/components/WhiteCard";
import EditPasswordModal from "./components/EditPasswordModal";
import { useState } from "react";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useTranslation } from "react-i18next";

interface Props {
  page: string;
}

const PasswordInformation = ({ page }: Props) => {
  const isMobile = useIsMobile();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const component = "passwordCard";
  const { t } = useTranslation();

  return (
    <>
      <WhiteCard>
        <Stack direction="row" gap={3}>
          <Typography variant={isMobile ? "body1" : "h6"} fontWeight={600}>
            {t(`${page}.${component}.title`)}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            sx={{ gap: 0.5, cursor: "pointer" }}
            onClick={() => setOpenModal(true)}
          >
            <EditPencilIcon />
            <Typography sx={{ color: "#00B6B9" }}>
              {t(`${page}.edit`)}
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Stack gap={1}>
            <Typography variant="subtitle1">
              {t(`${page}.${component}.current_password`)}
            </Typography>
            <Typography>********</Typography>
          </Stack>
        </Stack>
      </WhiteCard>
      <EditPasswordModal openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
};

export default PasswordInformation;
